<adapt-collapsible-search-row #row
                              [result]="result"
                              [matches]="matches"
                              [href$]="href$"
                              [crumbTemplate]="crumbs">
    <div class="d-flex flex-grow-1 align-items-center justify-content-between">
        <div class="d-flex flex-grow-0 align-items-center me-2 text-muted">
            <div class="d-flex align-items-center result-icon"
                 [adaptTooltip]="CAInputsViewOptions.text">
                <i [ngClass]="CAInputsViewOptions.iconClass"
                   class="fa-inverse"></i>
            </div>
        </div>

        <div class="flex-grow-1 text-break d-flex align-items-center">
            <adapt-highlighted-text [needle]="keyword"
                                    [haystack]="result.name"></adapt-highlighted-text>
        </div>
    </div>
</adapt-collapsible-search-row>

<ng-template #crumbs
             let-matched="match">
    @if (asMatch(matched); as match) {
        @for (crumb of match.field; track crumb; let first = $first; let last = $last) {
            @if (first && match.extra && InputTypeMetadata[match.extra.inputType]; as inputType) {
                <span><i [ngClass]="inputType.iconClass"></i> {{ inputType.singularLabel }}</span>
            } @else {
                <span>{{ crumb }}</span>
            }
            @if (!last) {
                <span class="px-1">&gt;</span>
            }
        }
    }
</ng-template>
